module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACkAAAAKCAYAAAApWHduAAAABHNCSVQICAgIfAhkiAAAALRJREFUOE/N07EVgjAUBdD/oKAlupA2etjCEXQD2cARGMEOOnECdQMZAMgC5BmscjyhNUmX6t+8vA8JfFbN8LCEHMCp36urj4PARlk3Ax1DOxGlLlTrumJDfm0UVobJjH3Pd9iX3AKnuVmab7EXkyXljHTjDuz1jm+jR5IskdfjYtz/iDUF/XWj3KcUR71Tz+gWx3bvZWhxzoZHgySlg+DcF6r6/cHwyHo8EJKbTCq9VdpXsQ9PhEiHDC7OUQAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/friend_right.png
// module id = ISjv
// module chunks = 1